import {
  Dialog,
  DialogTitle,
  Switch,
} from "@mui/material";
import React from "react";

const ToggleSwitchContainer = ({
  openToggle,
  setOpenToggle,
  checked,
  handleToggle,
}) => {
  const handleClose = () => {
    setOpenToggle(false);
  };
  return (
    <Dialog open={openToggle} onClose={handleClose}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DialogTitle>Toggle Switch</DialogTitle>
        <Switch
          checked={checked}
          onClick={() => {
            handleToggle();
          }}
        />
      </div>
    </Dialog>
  );
};

export default ToggleSwitchContainer;
